import { useLoginVerifyQuery } from '../../__generated__/chirp/com/hubspot/portals/platform/app/rpc/AccessRpc.hooks';
import { getPortalAccountId, getPortalInstanceId } from '../utils/metadata';
import { usePortalsPlatformObjectId } from '../context/PortalsPlatformObjectIdContext';

export function useIsUngated(gate: string): boolean {
  const accountId = getPortalAccountId();
  const portalInstanceId = getPortalInstanceId();
  const objectId = usePortalsPlatformObjectId();
  const { data: loginVerifyData } = useLoginVerifyQuery({
    variables: { accountId, portalInstanceId, objectId },
  });
  return loginVerifyData?.featuresEnabled?.includes(gate) ?? false;
}
